// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__3JBXV","point":"point__GIIDd","pointExpanded":"pointExpanded__1TM4e"};


//////////////////
// WEBPACK FOOTER
// ./components/point/style.styl
// module id = cw8p
// module chunks = 0